import { CustomButton } from "@/components/custom/custom-button";
import { DataTable } from "@/components/custom/data-table";
import { Box, Divider, styled, Typography } from "@mui/material";
import { RoutingProfileColumns } from "./_components/routing-profile-column";
import { useRoutingProfiles } from "@/hooks/use-routing-profiles";
import { useMemo, useState } from "react";
import CreateProfileDialog from "./_components/create-routing-profile";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const RoutingProfile = () => {
  const [newProfileOpen, setNewProfileOpen] = useState(false);

  const { data, isLoading, isError } = useRoutingProfiles(true);

  const columns = useMemo(() => RoutingProfileColumns, []);

  return (
    <RootWrapper>
      <Card>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={500} fontSize={18}>
            Routing Profiles
          </Typography>
          <CustomButton
            variantType="outline"
            onClick={() => setNewProfileOpen(true)}
            disabled={false}
            sx={{ minWidth: 100, px: 2 }}
          >
            New Profile
          </CustomButton>
        </Box>

        <Divider />

        <DataTable
          data={data?.data ?? []}
          columns={columns}
          isLoading={isLoading}
          isError={isError}
        />
      </Card>

      <CreateProfileDialog
        open={newProfileOpen}
        onClose={() => setNewProfileOpen(false)}
      />
    </RootWrapper>
  );
};

export default RoutingProfile;
